export const TEST_SESSION_DUR = 4; // hours